export var storagePrefix = '__xdomain_storage_';
export var sessionPrefix = '__xdomain_session_';
export var eventStorageKey = '__xdomain_event';
export var sessionStorageIndexKey = '__xdomain_sessions';
export var messageSignature = '__xdomain_message';
export var FrameMessageType;
(function (FrameMessageType) {
    FrameMessageType[FrameMessageType["MOUNT"] = 0] = "MOUNT";
    FrameMessageType[FrameMessageType["READY"] = 1] = "READY";
    FrameMessageType[FrameMessageType["EVENT"] = 2] = "EVENT";
    FrameMessageType[FrameMessageType["ON_EVENT"] = 3] = "ON_EVENT";
    FrameMessageType[FrameMessageType["UPDATE_SESSION"] = 4] = "UPDATE_SESSION";
    FrameMessageType[FrameMessageType["SET_STORAGE"] = 5] = "SET_STORAGE";
    FrameMessageType[FrameMessageType["GET_STORAGE"] = 6] = "GET_STORAGE";
    FrameMessageType[FrameMessageType["SET_STORAGE_RESPONSE"] = 7] = "SET_STORAGE_RESPONSE";
    FrameMessageType[FrameMessageType["GET_STORAGE_RESPONSE"] = 8] = "GET_STORAGE_RESPONSE";
})(FrameMessageType || (FrameMessageType = {}));
